import { createContext, useCallback, useContext, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EnquiryForm } from "@/components/enquiry/EnquiryForm";
import { findById, gbp } from "@/lib/inventory";

const EnquiryContext = createContext({ openEnquiry: () => {} });
export const useEnquiry = () => useContext(EnquiryContext);

export const EnquiryProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, vehicleId: "", mode: "enquiry", n: 0 });
  const openEnquiry = useCallback(
    ({ vehicleId = "", mode = "enquiry" } = {}) => setState((s) => ({ open: true, vehicleId, mode, n: s.n + 1 })),
    [],
  );
  const v = findById(state.vehicleId);

  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <Dialog open={state.open} onOpenChange={(open) => setState((s) => ({ ...s, open }))}>
        <DialogContent
          data-lenis-prevent
          className="max-h-[92dvh] w-[calc(100%-1.5rem)] max-w-2xl gap-0 overflow-y-auto rounded-lg p-0"
          data-testid="enquiry-dialog"
        >
          <div className="border-b border-line p-6 pr-14 sm:p-8 sm:pr-16">
            <p className="eyebrow">{state.mode === "viewing" ? "Book a viewing" : "Enquiry"}</p>
            <DialogTitle className="mt-3 font-display text-2xl font-extrabold leading-tight sm:text-3xl">
              {state.mode === "viewing" ? "Request a viewing" : "Enquire about this car"}
            </DialogTitle>
            <DialogDescription className="mt-2 text-sm text-steel">
              {v ? `${v.year} ${v.make} ${v.model} ${v.variant} · ${gbp(v.price)}` : "Tell us what you're looking for."}
            </DialogDescription>
            {v?.images?.[0] && (
              <img src={v.cardImage} alt="" className="mt-4 hidden aspect-[4/3] w-28 rounded-md object-cover sm:block" />
            )}
          </div>
          <div className="p-6 sm:p-8">
            <EnquiryForm key={state.n} defaultVehicleId={state.vehicleId} mode={state.mode} prefix={`dialog-${state.mode}`} />
          </div>
        </DialogContent>
      </Dialog>
    </EnquiryContext.Provider>
  );
};
